import { getCulture, getCountryFromCulture, getCookieValue } from "../../../utils/Utils";
import { countryCodes } from "../../../common/data/countryCodes";
import type { CountryCodesOption } from "../../../types/components";

type UseCountryCodesResult = {
  countryCodes: CountryCodesOption[];
  defaultCountry: string;
};

export function useCountryCodes(): UseCountryCodesResult {
  const defaultCountry = getCookieValue("Country")?.toUpperCase() ?? getCountryFromCulture(getCulture());
  return { countryCodes, defaultCountry };
}